// extracted by mini-css-extract-plugin
export var defaultWrapper = "_m1-3";
export var downloadButton = "_m1-4";
export var fileContainer = "_m1-9 _m1-7";
export var fileContainerBase = "_m1-7";
export var fileContainerFixedHeight = "_m1-8 _m1-7";
export var fileInfo = "_m1-5";
export var fileInfoWidthRestricted = "_m1-6";
export var fileType = "_m1-1";
export var fileTypeName = "_m1-2";
export var image = "_m1-0";
export var link = "_m1-b";
export var overflowEllipsis = "_m1-a";